import getBrand from 'system/getBrand'

const isSmxemail = () => getBrand() === 'smxemail'

export default isSmxemail
